
import request from '@/http/request'
 
/**
 * 产品查询接口
 * @param {*} data 
 * @returns 
 */
export function getProductList(params){
    return request({
        url:'/system/product/list',
        method:'get',
        params,  
 
    })
}
/**
 * 产品查询接口
 * @param {*} data 
 * @returns 
 */
export function getProductFilterType(params){
    return request({
        url:'/system/product/filterType',
        method:'get',
        params,  
 
    })
}


/**
 * 家族系列筛选
 * @param {*} data 
 * @returns 
 */
export function getProductFilter(data){
    return request({
        url:'/system/categories/filter',
        method:'post',
        data:data
    })
}
/**
 * 产品分类查询接口
 * @param {*} params 
 * @returns 
 */
export function getProductType(params){
    return request({
        url:'/system/categories/list',
        method:'get',
        params,  
    })
}

/**
 * 查询首页轮播配置
 * @param {*} params 
 * @returns 
 */
export function getHomeBanner(){
    return request({
        url:'/system/carousel/list',
        method:'get',
    })
}
 
/**
 * 查询首页公司轮播配置
 * @param {*} params 
 * @returns 
 */
export function getCompanyBanner(){
    return request({
        url:'/system/companycarousel/list',
        method:'get',
    })
}
/**
 * 查询首页视频配置列表
 * @param {*} params 
 * @returns 
 */
export function listVideo() {
    return request({
      url: '/system/video/list',
      method: 'get',
    })
  }
 